import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetScheduleList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/schedules/${queryUrl}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetScheduleConfig = async function(publicId) {
    try {
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/schedule/${publicId}/info`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetSchedulue = async function(parameters) {
    try {
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/schedule/${parameters}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteSchedule = async function(parameters) {
    try {
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicIds')
            )

        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/schedule`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const CreateSchedule = async function(parameters) {
    try {
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: model')
            )

        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/schedule`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const UpdateSchedule = async function(parameters) {
    try {
        const { publicId } = parameters
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: model')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/schedule/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteScheduleConfig = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/schedule-config`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
